<app-container [subpage]="true">
  <app-header-meta-action
    [title]="'Rechnung Nr. ' + invoice.data.invoiceNumber"
    [subTitle]="invoice.data.project.displayName"
  >
    <app-invoice-state-badge
      [invoiceState]="invoiceForm.controls.invoiceState.value"
    ></app-invoice-state-badge>
    @if (invoiceForm.controls.invoiceState.value !== 'canceled') {
      <button appTailwindButton color="secondary" (click)="setInvoiceCanceled.emit()">
        Rechnung stornieren
      </button>
    }
    @if (invoiceForm.controls.invoiceState.value === 'draft') {
      <button appTailwindButton (click)="setInvoiceReady.emit()" class="relative">
        Fertigstellen
      </button>
    }
    @if (invoiceForm.controls.invoiceState.value === 'ready') {
      <button appTailwindButton color="secondary" (click)="setInvoiceDraft.emit()">
        Editieren
      </button>
    }
    @if (invoiceForm.controls.invoiceState.value === 'ready') {
      <button appTailwindButton color="primary" (click)="setInvoiceSent.emit()">
        Rechnung versendet
      </button>
    }

    @if (invoiceForm.controls.invoiceState.value === 'sent') {
      <button appTailwindButton color="primary" (click)="setInvoicePaid.emit()">
        Rechnung bezahlt
      </button>
    }
    @if (invoiceForm.controls.invoiceState.value !== 'draft') {
      <button
        type="button"
        class="text-primary hover:text-blue-900 dark:hover:text-blue-400 transition ease-in-out duration-150"
        (click)="downloadDocument.emit()"
      >
        <app-ng-icon class="text-3xl" name="heroDocumentArrowDown"> </app-ng-icon>
      </button>
    }
  </app-header-meta-action>

  @if (false) {
    <app-alert
      class="md:col-span-6 w-full"
      heading="Eine oder mehrere Buchungen wurden bereits fakturiert"
      subheading="Lösche die betreffende Position und erstelle sie neu. Damit werden diese betroffenen Buchungen weggefiltert."
    ></app-alert>
  }

  @if (formInvalid) {
    <app-alert
      class="md:col-span-6 w-full"
      heading="Ein oder mehrere Pflichtfelder sind noch nicht ausgefüllt"
      subheading="Kontrolliere ob du alle Informationen angegeben hast."
    ></app-alert>
  }

  <app-tab-group (tabChanged)="saveInvoice.emit()">
    <ng-template appTab="Rechnungsinhalt">
      <app-invoice-content
        [invoiceForm]="invoiceForm"
        [users]="users"
        [customers]="customers"
        [invoicePositions]="invoicePositions"
        [invoiceSummary]="invoiceSummary"
        (importPositions)="openImportDialog.emit()"
        (addFreePosition)="openFreePositionDialog.emit(undefined)"
        (editFreePosition)="openFreePositionDialog.emit($event)"
        (deletedPosition)="deletedPosition.emit($event)"
        [isDisabled]="this.invoiceForm.controls.invoiceState.value !== 'draft'"
      ></app-invoice-content>
    </ng-template>
    <!--    <ng-template appTab="Stundenrapport">-->
    <!--      <app-badge class="mt-4" color="green">Coming Soon</app-badge>-->

    <!--      <app-work-table [columns]="['position', 'user']" [works]="[]"></app-work-table>-->
    <!--    </ng-template>-->
    @if (invoiceForm.controls.invoiceState.value === 'draft') {
      <ng-template appTab="Vorschau">
        @if (previewPdf; as previewPdf) {
          <app-invoice-preview [src]="previewPdf"></app-invoice-preview>
        }
      </ng-template>
    }
    @if (invoiceForm.controls.invoiceState.value !== 'draft') {
      <ng-template appTab="Rechnung">
        @if (previewPdf; as previewPdf) {
          <app-invoice-preview [src]="previewPdf"></app-invoice-preview>
        }
      </ng-template>
    }
    <ng-template appTab="Kommentare <small>({{ invoice.data.comments?.count ?? 0 }})</small>">
      <div class="flex w-full justify-center">
        @if (invoice; as invoice) {
          <app-comment-section
            class="w-full"
            [parentEntity]="invoice"
            parentEntityType="invoice"
          ></app-comment-section>
        }
      </div>
    </ng-template>
  </app-tab-group>
</app-container>
